import { Command } from 'commander';
import { ApiClient } from '../client.js';
import { formatOutput } from '../output.js';
import { getDatabase, getFormat, parseData } from '../helpers.js';
import { confirm } from '../prompt.js';

export const toolsCommand = new Command('tools')
  .description('Manage Tools — reusable, named single-operation definitions (one collection + one operation)');

toolsCommand.command('upsert <id>')
  .description('Create or update a Tool (one collection + one operation)')
  .option('--collection <collection>', 'The collection this tool operates over')
  .option('--operation <op>', 'The operation: create | get | list | update | delete')
  .option('--description <desc>', 'Agent-facing description')
  .option('--config <json>', 'Full Tool config as JSON (writable_fields, filterable_fields, precondition, binding, external_source, expose_*/default_*, agent_minimal). Use @file.json to read from file.')
  .action(async function (this: Command, id: string, opts: {
    collection?: string;
    operation?: string;
    description?: string;
    config?: string;
  }) {
    const ws = getDatabase(this);
    const client = new ApiClient();

    let body: Record<string, unknown>;
    if (opts.config) {
      body = parseData(opts.config);
      if (opts.collection) body.collection = opts.collection;
      if (opts.operation) body.operation = opts.operation;
      if (opts.description) body.description = opts.description;
    } else {
      if (!opts.collection || !opts.operation) {
        console.error('Provide --collection and --operation (or --config <json>).');
        process.exit(1);
      }
      body = { collection: opts.collection, operation: opts.operation };
      if (opts.description) body.description = opts.description;
    }

    const data = await client.request('PUT', `/v1/${ws}/tools/${id}`, body);
    console.log(formatOutput(data, getFormat(this)));
  });

toolsCommand.command('get <id>')
  .description('Get a Tool by id')
  .action(async function (this: Command, id: string) {
    const ws = getDatabase(this);
    const client = new ApiClient();
    const data = await client.request('GET', `/v1/${ws}/tools/${id}`);
    console.log(formatOutput(data, getFormat(this)));
  });

toolsCommand.command('list')
  .description('List Tools in this database')
  .action(async function (this: Command) {
    const ws = getDatabase(this);
    const client = new ApiClient();
    const data = await client.request('GET', `/v1/${ws}/tools`);
    console.log(formatOutput(data, getFormat(this)));
  });

toolsCommand.command('delete <id>')
  .description('Delete a Tool')
  .option('-y, --yes', 'Skip confirmation')
  .action(async function (this: Command, id: string, opts: { yes?: boolean }) {
    if (!opts.yes && !(await confirm(`Delete tool ${id}? This cannot be undone.`))) {
      console.log('Aborted.');
      return;
    }
    const ws = getDatabase(this);
    const client = new ApiClient();
    await client.request('DELETE', `/v1/${ws}/tools/${id}`);
    console.log(`Deleted tool ${id}`);
  });
